<template>
	<div class="flex-col page">
		<div class="flex-row justify-center">
			<img src="../assets/logo.png" class="logo" />
			<span @click="text_9OnClick" class="text_10">官网</span>
			<span @click="text_7OnClick" class="text_10">开通会员</span>
			<span @click="text0_OnClick" class="text_10">商铺入驻</span>
		</div>
		<div class="flex-row section_1">
			<div class="flex-col items-center group">
				<span @click="text_8OnClick">行言君商城</span>
				<div class="section_2"></div>
			</div>
			<span @click="textOnClick" class="text_1">便签</span>
			<span @click="text_1OnClick" class="text_2">办公文具</span>
			<span @click="text_2OnClick" class="text_3">文件收纳</span>
			<span @click="text_3OnClick" class="text_4">学生文具</span>
			<span @click="text_4OnClick" class="text_5">计算器</span>
			<span @click="text_5OnClick" class="text_6">画具画材</span>
			<span @click="text_6OnClick" class="text_7">文方四宝</span>
			<div class="flex-row section_3">
				<div class="flex-row group_1">
					<img src="../assets/16488068565369237271.png" class="image" />
					<span class="text_8">输入商品名称</span>
				</div>
				<div class="flex-col items-center text-wrapper">
					<span>搜索</span>
				</div>
			</div>
			<span @click="text_7OnClick" class="text_10">开通会员</span>
			<span @click="text_9OnClick" class="text_10">官网</span>
		</div>
		<div class="flex-col section_4">
			<div class="group_2 flex-row">
				<div class="left-section"></div>
				<span class="text_11">学生用品</span>
			</div>
			<div class="grid">
				<div @click="view_14OnClick" class="grid-item flex-col">
					<img src="../images/852593fb4a53375511db30182902e0d8.png" class="image_1" />
					<div class="center-group row flex-row">
						<span class="text_12">图书订</span>
						<span class="text_14">已有60人兑换</span>
					</div>
					<div class="center-group row_1 flex-row">
						<div class="left-group flex-row">
							<img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_3" />
							<span>600</span>
						</div>
						<span class="text_17">兑换</span>
					</div>
				</div>
				<div @click="view_15OnClick" class="grid-item flex-col">
					<img src="../images/c3f5e89680abeafb030decf5621edc91.png" class="image_1" />
					<div class="center-group row flex-row">
						<span class="text_12">图书订</span>
						<span class="text_14">已有60人兑换</span>
					</div>
					<div class="center-group row_1 flex-row">
						<div class="left-group flex-row">
							<img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_3" />
							<span>600</span>
						</div>
						<span class="text_17">兑换</span>
					</div>
				</div>
				<div @click="view_16OnClick" class="grid-item flex-col">
					<img src="../images/c782900ddfdbcc7f2183ea3f75215834.png" class="image_1" />
					<div class="center-group row flex-row">
						<span class="text_12">图书订</span>
						<span class="text_14">已有60人兑换</span>
					</div>
					<div class="center-group row_1 flex-row">
						<div class="left-group flex-row">
							<img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_3" />
							<span>600</span>
						</div>
						<span class="text_17">兑换</span>
					</div>
				</div>
				<div @click="view_17OnClick" class="grid-item flex-col">
					<img src="../images/8594db0b63643503505ad98be87dedaf.png" class="image_1" />
					<div class="center-group row flex-row">
						<span class="text_12">图书订</span>
						<span class="text_14">已有60人兑换</span>
					</div>
					<div class="center-group row_1 flex-row">
						<div class="left-group flex-row">
							<img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_3" />
							<span>600</span>
						</div>
						<span class="text_17">兑换</span>
					</div>
				</div>
				<div @click="view_18OnClick" class="grid-item flex-col">
					<img src="../images/fb68f8735c0c19f70c52409abf3baf70.png" class="image_1" />
					<div class="center-group row flex-row">
						<span class="text_12">图书订</span>
						<span class="text_14">已有60人兑换</span>
					</div>
					<div class="center-group row_1 flex-row">
						<div class="left-group flex-row">
							<img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_3" />
							<span>600</span>
						</div>
						<span class="text_17">兑换</span>
					</div>
				</div>
				<div @click="view_19OnClick" class="grid-item flex-col">
					<img src="../images/2cf4ff3518c75b3421838b3c6e6f9d82.png" class="image_1" />
					<div class="center-group row flex-row">
						<span class="text_12">图书订</span>
						<span class="text_14">已有60人兑换</span>
					</div>
					<div class="center-group row_1 flex-row">
						<div class="left-group flex-row">
							<img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_3" />
							<span>600</span>
						</div>
						<span class="text_17">兑换</span>
					</div>
				</div>
				<div @click="view_20OnClick" class="grid-item flex-col">
					<img src="../images/416f9cfaf39a0a00219a75200cc53f61.png" class="image_1" />
					<div class="center-group row flex-row">
						<span class="text_12">图书订</span>
						<span class="text_14">已有60人兑换</span>
					</div>
					<div class="center-group row_1 flex-row">
						<div class="left-group flex-row">
							<img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_3" />
							<span>600</span>
						</div>
						<span class="text_17">兑换</span>
					</div>
				</div>
				<div @click="view_21OnClick" class="grid-item flex-col">
					<img src="../images/5ecf69f6435a0d4fb44f85a754ee787c.png" class="image_1" />
					<div class="center-group row flex-row">
						<span class="text_12">图书订</span>
						<span class="text_14">已有60人兑换</span>
					</div>
					<div class="center-group row_1 flex-row">
						<div class="left-group flex-row">
							<img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_3" />
							<span>600</span>
						</div>
						<span class="text_17">兑换</span>
					</div>
				</div>
				<div @click="view_22OnClick" class="grid-item flex-col">
					<img src="../images/0b49f38b4c7ca88228791d6af3fa9329.png" class="image_1" />
					<div class="center-group row flex-row">
						<span class="text_12">图书订</span>
						<span class="text_14">已有60人兑换</span>
					</div>
					<div class="center-group row_1 flex-row">
						<div class="left-group flex-row">
							<img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_3" />
							<span>600</span>
						</div>
						<span class="text_17">兑换</span>
					</div>
				</div>
				<div @click="view_23OnClick" class="grid-item flex-col">
					<img src="../images/e22172a274c5b3d5dc5d61fe87927c97.png" class="image_1" />
					<div class="center-group row flex-row">
						<span class="text_12">图书订</span>
						<span class="text_14">已有60人兑换</span>
					</div>
					<div class="center-group row_1 flex-row">
						<div class="left-group flex-row">
							<img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_3" />
							<span>600</span>
						</div>
						<span class="text_17">兑换</span>
					</div>
				</div>
				<div @click="view_24OnClick" class="grid-item flex-col">
					<img src="../images/b135ff2f5c1c3f9e8a8b364e38870470.png" class="image_1" />
					<div class="center-group row flex-row">
						<span class="text_12">图书订</span>
						<span class="text_14">已有60人兑换</span>
					</div>
					<div class="center-group row_1 flex-row">
						<div class="left-group flex-row">
							<img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_3" />
							<span>600</span>
						</div>
						<span class="text_17">兑换</span>
					</div>
				</div>
				<div @click="view_25OnClick" class="flex-col grid-item_1">
					<img src="../images/652b00bcb6bc26bf512816bf1be26c59.png" class="image_1" />
					<div class="center-group flex-row view_35">
						<span class="text_59">图书订</span>
						<span class="text_60">已有60人兑换</span>
					</div>
					<div class="center-group flex-row view_36">
						<div class="left-group flex-row">
							<img src="../images/62b6e44b7268aab2b7a01ebc2c3cc8b5.png" class="image_3" />
							<span>600</span>
						</div>
						<span class="text_62">兑换</span>
					</div>
				</div>
			</div>
			<div class="divider"></div>
			<div class="group_2 flex-row view_38">
				<div class="left-section"></div>
				<span class="text_63">精选商铺</span>
			</div>
			<div class="flex-row equal-division">
				<div @click="view_27OnClick" class="equal-division-item flex-col items-center">
					<img src="../images/ded17155208738eb957fa2433f9eb454.png" class="image_27" />
					<span class="text_64">行言君官方旗舰店</span>
				</div>
				<div @click="view_28OnClick" class="equal-division-item flex-col items-center">
					<img src="../images/20c8a2c49e8d55de6b7fdd539f1c15ea.png" class="image_27" />
					<span class="text_64">司号官方旗舰店</span>
				</div>
				<div @click="view_29OnClick" class="equal-division-item flex-col items-center">
					<img src="../images/e8161ec52462a47d5c54b927ce4d6f6e.png" class="image_27" />
					<span class="text_64">希尔桥官方旗舰店</span>
				</div>
				<div @click="view_30OnClick" class="equal-division-item flex-col items-center">
					<img src="../images/0adcf44ce90d9caf4aeb01a38f1bc053.png" class="image_27" />
					<span class="text_64">艾斯官方旗舰店</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {};
		},
		methods: {
			text0_OnClick() {
				this.$router.push({
					name: 'shangjiaruzhu'
				});
			},
			text_9OnClick() {
				parent.location.href = '../index.html'
			},
			text_8OnClick() {
				this.$router.push({
					name: 'index'
				});
			},
			textOnClick() {
				this.$router.push({
					name: 'bianqian'
				});
			},
			text_1OnClick() {
				this.$router.push({
					name: 'bangongwenju'
				});
			},
			text_2OnClick() {
				this.$router.push({
					name: 'wenjushouna'
				});
			},
			text_3OnClick() {
				this.$router.push({
					name: 'xueshengwenju'
				});
			},
			text_4OnClick() {
				this.$router.push({
					name: 'jisuanqi'
				});
			},
			text_5OnClick() {
				this.$router.push({
					name: 'huajuhuacai'
				});
			},
			text_6OnClick() {
				this.$router.push({
					name: 'wenfangsibao'
				});
			},
			text_7OnClick() {
				this.$router.push({
					name: 'Page_huiyuankaitongyemianbeifen_2'
				});
			},
			view_14OnClick() {
				this.$router.push({
					name: 'Page_shangpinxiangqingyemian'
				});
			},
			view_15OnClick() {
				this.$router.push({
					name: 'Page_shangpinxiangqingyemian'
				});
			},
			view_16OnClick() {
				this.$router.push({
					name: 'Page_shangpinxiangqingyemian'
				});
			},
			view_17OnClick() {
				this.$router.push({
					name: 'Page_shangpinxiangqingyemian'
				});
			},
			view_18OnClick() {
				this.$router.push({
					name: 'Page_shangpinxiangqingyemian'
				});
			},
			view_19OnClick() {
				this.$router.push({
					name: 'Page_shangpinxiangqingyemian'
				});
			},
			view_20OnClick() {
				this.$router.push({
					name: 'Page_shangpinxiangqingyemian'
				});
			},
			view_21OnClick() {
				this.$router.push({
					name: 'Page_shangpinxiangqingyemian'
				});
			},
			view_22OnClick() {
				this.$router.push({
					name: 'Page_shangpinxiangqingyemian'
				});
			},
			view_23OnClick() {
				this.$router.push({
					name: 'Page_shangpinxiangqingyemian'
				});
			},
			view_24OnClick() {
				this.$router.push({
					name: 'Page_shangpinxiangqingyemian'
				});
			},
			view_25OnClick() {
				this.$router.push({
					name: 'Page_shangpinxiangqingyemian'
				});
			},
			view_27OnClick() {
				this.$router.push({
					name: 'Page_junbishangcheng'
				});
			},
			view_28OnClick() {
				this.$router.push({
					name: 'Page_junbishangcheng'
				});
			},
			view_29OnClick() {
				this.$router.push({
					name: 'Page_junbishangcheng'
				});
			},
			view_30OnClick() {
				this.$router.push({
					name: 'Page_junbishangcheng'
				});
			},
		},
	};
</script>

<style scoped lang="css">
	
	.logo{
		position: fixed;
		top:0.4rem;
		left: 1rem;
		width: 1.2rem;
		height: 0.6rem;
		z-index: 99;
	}
	.group_2 {
		color: rgb(67, 65, 65);
		font-size: 0.34rem;
		font-weight: 600;
		line-height: 0.47rem;
		white-space: nowrap;
		padding: 0 0.25rem;
	}

	.left-section {
		margin: 0.13rem 0 0.094rem;
		background-color: rgb(252, 182, 21);
		border-radius: 0.031rem;
		width: 0.031rem;
		height: 0.25rem;
	}

	.grid-item {
		padding-bottom: 0.13rem;
		background-color: rgb(255, 255, 255);
		box-shadow: 0px 0px 0.083rem 0px rgba(0, 0, 0, 0.09);
		position: relative;
	}

	.equal-division-item {
		flex: 1 1 3.75rem;
		padding: 0.31rem 0 0.31rem;
	}

	.image_1 {
		width: 2.25rem;
		height: 2.25rem;
	}

	.center-group {
		padding: 0 0.094rem;
	}

	.image_27 {
		background-color: rgb(255, 255, 255);
		width: 3.59rem;
		height: 2.59rem;
	}

	.left-group {
		color: rgb(255, 112, 103);
		font-size: 0.19rem;
		line-height: 0.22rem;
		white-space: nowrap;
		width: 0.63rem;
	}

	.image_3 {
		width: 0.22rem;
		height: 0.22rem;
	}

	.text_12 {
		color: rgb(8, 4, 23);
		font-size: 0.19rem;
		font-weight: 500;
		line-height: 0.25rem;
		white-space: nowrap;
	}

	.row {
		margin-top: 0.063rem;
	}

	.row_1 {
		margin-top: 0.094rem;
	}

	.text_64 {
		margin-top: 0.22rem;
	}

	.text_14 {
		margin-left: 0.63rem;
		color: rgb(8, 4, 23);
		font-size: 0.13rem;
		line-height: 0.19rem;
		white-space: nowrap;
	}

	.text_17 {
		margin-left: 1.06rem;
		color: rgb(236, 82, 72);
		font-size: 0.16rem;
		line-height: 0.22rem;
		white-space: nowrap;
	}

	.page {
		padding-bottom: 0.53rem;
		background-color: #f2f2f4;
		width: 100%;
		overflow-y: auto;
		height: 100%;
	}

	.section_1 {
		padding: 0.16rem 0 0.16rem;
		background-color: rgb(255, 255, 255);
		box-shadow: 0px 0.011rem 0px 0px rgb(245, 86, 86);
		position: relative;
	}

	.section_4 {
		padding: 0.25rem 0 0.28rem;
		align-self: center;
		background-color: rgb(255, 255, 255);
		width: 15rem;
	}

	.group {
		margin-left: 2.94rem;
		padding-bottom: 0.063rem;
		color: rgb(255, 73, 73);
		font-size: 0.22rem;
		font-weight: 500;
		line-height: 0.31rem;
		white-space: nowrap;
		position: relative;
	}

	.text_1 {
		margin-left: 0.47rem;
		margin-bottom: 0.094rem;
		color: rgb(67, 65, 65);
		font-size: 0.19rem;
		font-weight: 500;
		line-height: 0.25rem;
		white-space: nowrap;
	}

	.text_2 {
		margin-left: 0.53rem;
		margin-bottom: 0.094rem;
		color: rgb(67, 65, 65);
		font-size: 0.19rem;
		font-weight: 500;
		line-height: 0.25rem;
		white-space: nowrap;
	}

	.text_3 {
		margin-left: 0.53rem;
		margin-bottom: 0.094rem;
		color: rgb(67, 65, 65);
		font-size: 0.19rem;
		font-weight: 500;
		line-height: 0.25rem;
		white-space: nowrap;
	}

	.text_4 {
		margin-left: 0.53rem;
		margin-bottom: 0.094rem;
		color: rgb(67, 65, 65);
		font-size: 0.19rem;
		font-weight: 500;
		line-height: 0.25rem;
		white-space: nowrap;
	}

	.text_5 {
		margin-left: 0.53rem;
		margin-bottom: 0.094rem;
		color: rgb(67, 65, 65);
		font-size: 0.19rem;
		font-weight: 500;
		line-height: 0.25rem;
		white-space: nowrap;
	}

	.text_6 {
		margin-left: 0.53rem;
		margin-bottom: 0.094rem;
		color: rgb(67, 65, 65);
		font-size: 0.19rem;
		font-weight: 500;
		line-height: 0.25rem;
		white-space: nowrap;
	}

	.text_7 {
		margin-left: 0.53rem;
		margin-bottom: 0.094rem;
		color: rgb(67, 65, 65);
		font-size: 0.19rem;
		font-weight: 500;
		line-height: 0.25rem;
		white-space: nowrap;
	}

	.section_3 {
		margin-left: 1.13rem;
		padding-left: 0.13rem;
		background-color: rgb(255, 255, 255);
		border-radius: 0.031rem;
		height: 0.41rem;
		border: solid 0.063rem rgb(245, 86, 86);
	}

	.text_10 {
		margin-left: 0.28rem;
		color: rgb(245, 86, 86);
		font-size: 0.22rem;
		font-weight: 500;
		line-height: 0.31rem;
		white-space: nowrap;
	}

	.grid {
		margin: 0.47rem 0.25rem 0;
		height: 6.31rem;
		display: grid;
		grid-template-columns: repeat(6, 1fr);
		grid-row-gap: 0.31rem;
	}

	.divider {
		margin-top: 0.59rem;
		background-color: rgb(235, 235, 235);
		height: 0.063rem;
	}

	.view_38 {
		margin-top: 0.47rem;
	}

	.equal-division {
		color: rgb(75, 72, 72);
		font-size: 0.25rem;
		font-weight: 900;
		line-height: 0.34rem;
		white-space: nowrap;
		border-bottom: solid 0.063rem rgb(235, 235, 235);
	}

	.section_2 {
		background-color: rgb(255, 73, 73);
		width: 0.28rem;
		height: 0.063rem;
		position: absolute;
		left: 0.094rem;
		bottom: 0;
	}

	.group_1 {
		color: rgb(125, 122, 133);
		font-size: 0.16rem;
		line-height: 0.22rem;
		white-space: nowrap;
	}

	.text-wrapper {
		padding-top: -0.10rem;
		margin-left: 0.83rem;
		margin-top: -0.00rem;
		color: rgb(255, 255, 255);
		font-size: 0.17rem;
		font-weight: 500;
		line-height: 0.18rem;
		/* white-space: nowrap; */
		background-color: rgb(245, 86, 86);
		border-radius: 0.031rem;
		width: 0.78rem;
		height: 0.28rem;
		border: solid 0.063rem rgb(245, 86, 86);
	}

	.text_11 {
		margin-left: 0.13rem;
	}

	.grid-item_1 {
		padding-bottom: 0.13rem;
		background-color: rgb(255, 255, 255);
		box-shadow: 0px 0px 0.083rem 0px rgba(0, 0, 0, 0.09);
	}

	.text_63 {
		margin-left: 0.094rem;
	}

	.image {
		width: 0.38rem;
		height: 0.28rem;
	}

	.text_8 {
		margin-left: 0.13rem;
	}

	.view_35 {
		margin-top: 0.063rem;
	}

	.view_36 {
		margin-top: 0.094rem;
	}

	.text_59 {
		color: rgb(8, 4, 23);
		font-size: 0.19rem;
		font-weight: 500;
		line-height: 0.25rem;
		white-space: nowrap;
	}

	.text_60 {
		margin-left: 0.63rem;
		color: rgb(8, 4, 23);
		font-size: 0.13rem;
		line-height: 0.19rem;
		white-space: nowrap;
	}

	.text_62 {
		margin-left: 1.06rem;
		color: rgb(236, 82, 72);
		font-size: 0.16rem;
		line-height: 0.22rem;
		white-space: nowrap;
	}
</style>
